module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Rouble-1f0354f7bfda86e7108708caa90a1570.svg";